import {
  FILL_LIST, ASSIGN_MENU_ELEMENT, UNASSIGN_MENU_ELEMENT,
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    const _state = state;
    _state.list.records = payload.records;
    _state.list.total = payload.total;
  },
  [ASSIGN_MENU_ELEMENT](state, payload) {
    const _state = state;
    const menuId = payload.params.mainMenuId;
    const { elementMenuId } = payload.params;
    const { keypadNumber } = payload.params;

    _state.list.records = _state.list.records.map(menu => (menu.id === menuId
      ? { ...menu, [keypadNumber]: elementMenuId }
      : menu));
  },
  [UNASSIGN_MENU_ELEMENT](state, payload) {
    const _state = state;
    const menuId = payload.params.mainMenuId;
    const { oldKeypadNumber } = payload.params;

    _state.list.records = _state.list.records.map(menu => (menu.id === menuId
      ? { ...menu, [oldKeypadNumber]: 0 }
      : menu));
  },
};
